import React, { ReactElement } from 'react';
import type { AppLayoutProps } from 'next/app';
import Head from 'next/head';
import { RecoilRoot } from 'recoil';

import NotificationToaster from 'components/NotificationToaster';
import IntercomLauncher from 'components/IntercomLauncher';

import 'styles/globals.css';
import 'styles/theme.scss';

function MyApp({ Component, pageProps }: AppLayoutProps): ReactElement {
  const getLayout = Component.getLayout || ((page: React.ReactNode) => page);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <RecoilRoot>
        {getLayout(<Component {...pageProps} />)}
        <NotificationToaster />
        <IntercomLauncher />
      </RecoilRoot>
    </>
  );
}

export default MyApp;
